const prices = {
  twoD: {
    openDays: ['', 'Poniedziałek', 'Wtorek-Piątek', 'Weekend'],
    normalTicket: ['Bilet normalny', '15 zł', '21 zł', '25zł'],
    kidPupilTicket: ['Dziecięcy i Studencki', '10zł', '16zł', '16zł'],
    senior: ['Emeryci', '12zł', '17zł', '18zł']
  },
  threeD: {
    openDays: ['', 'Poniedziałek', 'Wtorek-Piątek', 'Weekend'],
    normalTicket: ['Bilet normalny', '25 zł', '28 zł', '30zł'],
    kidPupilTicket: ['Dziecięcy i Studencki', '18zł', '20zł', '22zł'],
    senior: ['Emeryci', '20zł', '22zł', '26zł']
  }
};

export default prices;
